<template>
  <div
    class="bloc d-inline-flex text-center align-center"
    style="height:55px"
  >
    <v-btn
      text
      class="ma-0 pa-0"
      @click="del"
    >
      <v-icon large>
        {{ IconEnum.minus }}
      </v-icon>
    </v-btn>
    <span
      class="title mx-2"
    >{{ value }}</span>
    <v-btn
      text
      class="ma-0 pa-0"
      @click="add"
    >
      <v-icon large>
        {{ IconEnum.plus }}
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { IconEnum } from '@/modules/Enums'

export default {
  name: 'Counter',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: { type: Number, required: true },
    min: { type: Number, default: null },
    max: { type: Number, default: null }
  },

  data () {
    return {
      IconEnum
    }
  },

  methods: {
    del () {
      if (this.min === null || (this.value - 1 >= this.min)) {
        this.$emit('input', this.value - 1)
      }
    },
    add () {
      if (this.max === null || (this.value < this.max)) {
        this.$emit('input', this.value + 1)
      }
    }
  }
}
</script>
